// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"368":"1860ec50","445":"8cbedec0","624":"d0d45c23","738":"dc26d8e5"}[chunkId] + ".css";
};